// Color constants matching the mobile app styling
// Based on mobile app colors from /Users/alek/Documents/mob-fe/constants/Colors.ts

export const Colors = {
  // Background colors
  background: "#191919",
  tabBackground: "#222321",

  // Text colors
  text: {
    primary: "#ECEDEE",
    secondary: "#9BA1A6",
  },

  // Accent colors
  primary: "#16A34A", // Green accent
  secondary: "#828382",

  // Border colors
  greyBorders: "#5D625F",
  tabBorderTopColor: "#828382",

  // Chat colors
  chatMsgInput: "#282A29",

  // Tab bar colors
  tabBarActiveTintColor: "#16A34A",
  tabBarInactiveTintColor: "#828382",

  // Status colors
  success: "#22c55e",
  error: "#ef4444",
  warning: "#f59e0b",
  info: "#3b82f6",

  // Chart colors (for consistency with mobile)
  chart: {
    primary: "#8884d8",
    secondary: "#82ca9d",
    tertiary: "#ffc658",
    quaternary: "#ff8042",
    quinary: "#a4de6c",
    senary: "#d0ed57",
  }
};

export default Colors;
